import { Component } from '@angular/core';

@Component({
  selector: 'app-new-account-mobile-finished-state',
  templateUrl: './new-account-mobile-finished-state.component.html',
  styleUrls: [
    '../../shared-styles/new-account-device-view.component.scss',
    './new-account-mobile-finished-state.component.scss',
  ],
  standalone: false,
})
export class NewAccountMobileFinishedStateComponent {}
